import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { ArrowRightNew } from '@/icons/index';

import SectionTitle from '../SectionTitle/SectionTitle';
import TextBlock from '../TextBlock/TextBlock';
import ActiveLink from '../ActiveLink/ActiveLink';

import styles from './BusinessServicesCardWithImage.module.scss';

const BusinessServicesCardWithImage = ({ data }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <ActiveLink
      href={data?.link}
      itemScope
      itemType='https://schema.org/Article'
    >
      <a
        title={data?.title}
        aria-label={data?.title}
        className={styles['card-item']}
      >
        {!isImageLoaded && <Skeleton width='100%' height='100%' />}

        <Image
          className={styles.shape}
          src='/assets/serviceShape.png'
          alt='shape'
          title='shape'
          layout='fill'
          onLoadingComplete={() => setIsImageLoaded(true)}
          style={{
            visibility: isImageLoaded ? 'visible' : 'hidden',
          }}
        />
        {data?.image && (
          <Image
            alt={data?.title}
            title={data?.title}
            src={data.image}
            className={styles.image}
            layout={'fill'}
            loading='lazy'
            onLoadingComplete={() => setIsImageLoaded(true)}
            style={{
              visibility: isImageLoaded ? 'visible' : 'hidden',
            }}
          />
        )}
        <div className={styles.content}>
          <div className={styles.inner}>
            <div className={styles['card-item__content']}>
              {data?.title && (
                <SectionTitle titleModify={styles['card-item__title']}>
                  {data.title}
                </SectionTitle>
              )}
              {data?.description && (
                <TextBlock className={styles['card-item__desc']}>
                  {data.description}
                </TextBlock>
              )}
            </div>
          </div>
          <div className={styles.link}>
            <Link href={`/${data?.slug}`}>
              <a
                title={data?.title}
                aria-label={data?.title}
                data-testid='fiber-optik-internet'
              >
                {data?.link_text} <ArrowRightNew width={18} />
              </a>
            </Link>
          </div>
        </div>
      </a>
    </ActiveLink>
  );
};

export default BusinessServicesCardWithImage;
